export default __webpack_public_path__ + "static/media/flag-kazakhstan.bef6e037.svg";